/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PageBox from 'Components/PageBox';
import Button from 'Components/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './PageSelector.scss';
import { VITE_TRANSACTION_UNMATCHED_QUEUE } from 'Constants/appEnvConstants';

export class PageSelector extends Component {
  constructor(props) {
    super(props);

    this.attachBindings();
  }

  attachBindings() {
    this.updateSelectedPages = this.updateSelectedPages.bind(this);
    this.selectAllPages = this.selectAllPages.bind(this);
    this.clearAllPages = this.clearAllPages.bind(this);
  }

  updateSelectedPages(newPage) {
    if (this.props.type != undefined && this.props.type != VITE_TRANSACTION_UNMATCHED_QUEUE && this.props.pageList.length >= this.props.selectedPages.length) {
      this.props.isSelectedFlag(this.props.selectAllFlag);
    }
      
    let selectedPagesClone = [...this.props.selectedPages];

    const currentDoc = this.props.pageList.find(page => {
      return page.pageId === newPage.pageId && page.documentType === "Docs to the Issuer-no conversion"  && ["EMD", "MXP"].includes(this.props.acquirerCode) ;
    });

    // If a matching document is found, add docId and docName to newPage
    if (currentDoc) {
      newPage.docId = currentDoc.docId;
      newPage.documentName = currentDoc.documentName;
      newPage.documentType = currentDoc.documentType;
    }else{
      const otherDoc = this.props.pageList.find(page =>page.pageId === newPage.pageId );
      if (otherDoc) {
        newPage.documentType = otherDoc.documentType;
      }
    }

    const updateIndex = selectedPagesClone.findIndex((page) => {
      return page.pageId === newPage.pageId;
    });

    if (updateIndex !== -1) {
      // toggle the page selection
      if (newPage.selectedIndex) {
        selectedPagesClone[updateIndex].isSelected = true;
      } else {
        // delete from list
        selectedPagesClone.splice(updateIndex, 1);
      }
    } else {
      // add page in selected list
      newPage.isSelected = true;
      newPage.addedWhen = Date.now();
      selectedPagesClone = selectedPagesClone.concat(newPage);
    }

    this.props.updateParentSelectedPages(selectedPagesClone,this.props.id);
  }


  selectAllPages() {
    
    let allSelectedPages;
    allSelectedPages = this.props.pageList.map((page) => {
      return { ...page, isSelected: true, addedWhen: Date.now() + page.pageId, };
    })

    this.props.updateParentSelectedPages(allSelectedPages,this.props.id);
    
    if(this.props.pageList.length === this.props.selectedPages.length){
    const isSelectedFlag = this.props.selectAllFlag;
    this.props.isSelectedFlag(isSelectedFlag);}
    else
    this.props.isSelectedFlag(!this.props.selectAllFlag);
  }

  clearAllPages() {
    let allSelectedPages;
    allSelectedPages = this.props.pageList.map((page) => {
      return { ...page, isSelected: false, addedWhen: Date.now() + page.pageId, };
    })

    this.props.updateParentSelectedPages(allSelectedPages,this.props.id);

    if(this.props.pageList.length === this.props.selectedPages.length){
    const isSelectedFlag = this.props.selectAllFlag;
    this.props.isSelectedFlag(isSelectedFlag);}
    else
    this.props.isSelectedFlag(!this.props.selectAllFlag);
  }

  render() {
    let selectedPagesClone = [...this.props.selectedPages];
    const { selectedPages, pageList, toolkitModal, pageselectormodal } = this.props;
    let pageSelectorClass = toolkitModal ? 'modal-selector' : pageselectormodal != undefined ? 'pageselectormodal' : '';
    let iterableCount = 0;

    if (pageselectormodal == 'pageselectorimageselection') {
      pageSelectorClass = 'pageselectorimageselection';
    } else if (pageselectormodal == 'pageselectorimageselectionnomodal') {
      pageSelectorClass = 'pageselectorimageselectionnomodal';
    }

    if (this.props.collatedPageSeq) {
      selectedPagesClone = selectedPagesClone.filter(page => page.isSelected === true);
    }

    return (
      <div key={this.props.id} className={`page-selector-wrapper ${pageSelectorClass}`} style={pageSelectorClass == 'pageselectorimageselection' ? { marginBottom: 0 } : {}}>
        {this.props.selectAllButtonRequired && (
          <>
            <div tabIndex="0" className="select-all-button">
              <button type="button" class="hollow-button-select">
                <label className="hollow-label-view" onClick={this.selectAllPages}>Select All Pages</label>
              </button>
              <button type="button" class="hollow-button-clear" onClick={this.clearAllPages}>
                <label className="hollow-label-view">Clear All Pages</label>
              </button>
            </div>
            {
              toolkitModal &&
              this.props.user &&
              this.props.user.parsedPermissions
              && this.props.user.parsedPermissions.queue &&
              this.props.user.parsedPermissions.queue.unlinkImage && (
                <Button disabled={selectedPages.length === 0} extraClass="select-all-button unlink" action={() => this.props.unlinkSelectedImages(selectedPages)}>
                  {`Unlink (${pageList.length === selectedPages.length ? 'All' : selectedPages.length})`}
                </Button>
              )}
          </>
        )}
        {this.props.pageList.map((page, pageIndex) => {
          let selectedIndex = -1;
          selectedIndex = selectedPagesClone.findIndex((spage) => {
            return spage.pageId === page.pageId && spage.isSelected;
          });


          let updatedIndex = -1;
          if (selectedIndex !== -1) {
            if (this.props.collatedPageSeq === false) {
              updatedIndex = selectedIndex + 1;
            } else {
              updatedIndex = this.props.userSelectedImageOrder.findIndex((userDisplayPage) => {
                return userDisplayPage.pageNumber === this.props.id && userDisplayPage.pageId === page.pageId;
              });
              updatedIndex++;
            }
          }
          return (
            <PageBox
              currentIndex={updatedIndex === 0 ? -1 : updatedIndex}
              page={page}
              pageIndex={pageIndex}
              toggleSelectedPage={this.updateSelectedPages}
              canvasSelectedIndex={this.props.canvasSelectedIndex}
              updatePageSelectionIndex={this.props.updatePageSelectionIndex}
              summaryData={this.props.summaryData}
              selectAllFlag={this.props.selectAllFlag}
              imageCheckBoxRequired={this.props.imageCheckBoxRequired}
              imageStyle={this.props.imageStyle}
              id={this.props.id}
              updateCurrentSelectedImageIndex={this.props.updateCurrentSelectedImageIndex}
            />
          );
        })}
      </div>
    );
  }
}

PageSelector.propTypes = {
  pageList: PropTypes.array.isRequired,
  toolkitModal: PropTypes.bool,
  updatePageSelectionIndex: PropTypes.func,
  updateParentSelectedPages: PropTypes.func,
  canvasSelectedIndex: PropTypes.number,
  selectAllButtonRequired: PropTypes.bool,
  selectAllFlag: PropTypes.bool,
  selectedPages: PropTypes.array,
  isSelectedFlag:PropTypes.func,
  unlinkSelectedImages: PropTypes.func,
  collatedPageSeq: PropTypes.bool,
  updateCurrentSelectedImageIndex: PropTypes.func
};
PageSelector.defaultProps = {
  extraStyle: {},
  toolkitModal: false,
  unlinkSelectedImages: () => { },
  updatePageSelectionIndex: () => { },
  updateParentSelectedPages: () => { },
  selectAllButtonRequired: true,
  selectedPages: [],
  selectAllFlag: false,
  collatedPageSeq: false,
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(PageSelector);
